import React from 'react';
import ReactDOM from 'react-dom/client';
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
import Header from './components/Header/Header';
import './index.css';

import App from './pages/Home/App';
import Options from './pages/Options/Options';
import Results from './pages/Results/Results';
import Votings from './pages/Votings/Votings';
import Login from './pages/Login/Login';
import Polls from './pages/Polls/Polls';
import PollResults from './pages/PollResults/PollResults';

import SingleOption from './pages/SingleOption/SingleOption';

import PrivateRedirect from './components/PrivateRedirect/PrivateRedirect';
import Tags from './pages/Tags/Tags';
import SingleVoting from './pages/SingleVoting/SingleVoting';
import SingleResult from './pages/SingleResult/SingleResult';
import Statistics from './pages/Statistics/Statistics';


// import reportWebVitals from './reportWebVitals';

// @ts-ignore

ReactDOM.createRoot(document.getElementById('root')).render(
  // <React.StrictMode>
  <BrowserRouter>
    <Header />
    <div style={{ width: '100vw', paddingTop: '90px', height: 'calc(100vh - 90px)' }}>
      <Routes>
        <Route path='/' element={<PrivateRedirect />}>
          <Route path='/' element={<App />} />
        </Route>
        <Route path='/' element={<PrivateRedirect />}>
          <Route path="/ustawienia" element={<Options />} />
        </Route>
        <Route path='/' element={<PrivateRedirect />}>
          <Route path="/wyniki" element={<Results />} />
        </Route>
        <Route path='/' element={<PrivateRedirect />}>
          <Route path="/glosowania" element={<Votings />} />
        </Route>
        <Route path='/' element={<PrivateRedirect />}>
          <Route path="/listaglosowan" element={<Polls />} >
            <Route path=":id" element={<Polls />} />
          </Route>
        </Route>
        <Route path='/' element={<PrivateRedirect />}>
          <Route path="/listawynikow" element={<PollResults />} >
            <Route path=":id" element={<PollResults />} />
          </Route>
        </Route>
        <Route path='/' element={<PrivateRedirect />}>
          <Route path="/tagi" element={<Tags />} >
          </Route>
        </Route>
        <Route path='/' element={<PrivateRedirect />}>
          <Route path="/glosowanie" element={<SingleVoting />} >
            <Route path=":id" element={<SingleVoting />} />
          </Route>
        </Route>
        <Route path='/' element={<PrivateRedirect />}>
          <Route path="/wynik" element={<SingleResult />} >
            <Route path=":id" element={<SingleResult />} />
          </Route>
        </Route>
        <Route path='/' element={<PrivateRedirect />}>
          <Route path="/opcja" element={<SingleOption />} >
            <Route path=":id" element={<SingleOption />} />
          </Route>
        </Route>
        <Route path='/' element={<PrivateRedirect />}>
          <Route path="/statystyki" element={<Statistics />} >
            <Route path=":id" element={<Statistics />} />
          </Route>
        </Route>

        <Route path="/login" element={<Login />} />
      </Routes>
    </div>
  </BrowserRouter>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
